export const CONFIG_IMPRESSAO_PEDIDO_FIELDS = [
  { chave: "numeroPedido", label: "Número do pedido", grupo: "cabecalho" },
  { chave: "numeroErp", label: "Número ERP", grupo: "cabecalho" },
  { chave: "statusPedido", label: "Status do pedido", grupo: "cabecalho" },
  { chave: "horaCompra", label: "Hora da compra", grupo: "cabecalho" },
  { chave: "totalPedido", label: "Total do pedido", grupo: "cabecalho" },
  {
    chave: "nomeCliente",
    label: "Nome do cliente",
    grupo: "cabecalho"
  },
  { chave: "cpfCnpjCliente", label: "CPF/CNPJ do cliente", grupo: "cabecalho" },
  {
    chave: "documentoAdicionalCliente",
    label: "Documento adicional do cliente",
    grupo: "cabecalho"
  },
  { chave: "emailCliente", label: "E-mail do cliente", grupo: "cabecalho" },
  { chave: "telefone", label: "Telefone", grupo: "cabecalho" },
  { chave: "formaPagamento", label: "Forma de pagamento", grupo: "cabecalho" },
  { chave: "parcelamento", label: "Parcelamento", grupo: "cabecalho" },
  { chave: "bandeira", label: "Bandeira", grupo: "cabecalho" },
  { chave: "nsu", label: "Sequencial/NSU", grupo: "cabecalho" },
  {
    chave: "enderecoFaturamento",
    label: "Endereço de faturamento",
    grupo: "cabecalho"
  },
  {
    chave: "enderecoEntrega",
    label: "Endereço de entrega",
    grupo: "cabecalho"
  },
  {
    chave: "enderecoRetirada",
    label: "Endereço de retirada",
    grupo: "cabecalho"
  },
  { chave: "linkRastreio", label: "Link de rastreio", grupo: "cabecalho" },
  { chave: "linkEtiqueta", label: "Link da etiqueta", grupo: "cabecalho" },
  { chave: "formaEntrega", label: "Forma de entrega", grupo: "cabecalho" },
  {
    chave: "dataHoraCombinada",
    label: "Data e hora combinada",
    grupo: "cabecalho"
  },
  {
    chave: "responsavelPedido",
    label: "Responsável pelo pedido",
    grupo: "cabecalho"
  },
  {
    chave: "responsavelSeparacao",
    label: "Responsável pela separação",
    grupo: "cabecalho"
  },
  {
    chave: "responsavelEntrega",
    label: "Responsável pela entrega",
    grupo: "cabecalho"
  },
  {
    chave: "representantePedido",
    label: "Representante do pedido",
    grupo: "cabecalho"
  },
  { chave: "usuarioPedido", label: "Usuário do pedido", grupo: "cabecalho" },
  {
    chave: "responsavelVenda",
    label: "Responsável pela venda",
    grupo: "cabecalho"
  },
  { chave: "tipoEntrega", label: "Tipo de entrega", grupo: "cabecalho" },
  {
    chave: "caracteristicasDinamicas",
    label: "Características dinâmicas do pedido",
    grupo: "cabecalho"
  },
  {
    chave: "anotacoesCliente",
    label: "Anotações do cliente",
    grupo: "cabecalho"
  },
  { chave: "nomeItem", label: "Nome do item", grupo: "itens" },
  {
    chave: "codigoBarrasProduto",
    label: "Código de barras do produto",
    grupo: "itens"
  },
  {
    chave: "codigoInternoItem",
    label: "Código interno (ID ERP do item)",
    grupo: "itens"
  },
  { chave: "quantidade", label: "Quantidade", grupo: "itens" },
  { chave: "precoUnitario", label: "Preço unitário", grupo: "itens" },
  { chave: "totalItem", label: "Total do item", grupo: "itens" },
  { chave: "subtotalCompras", label: "Subtotal de compras", grupo: "totais" },
  { chave: "taxas", label: "Taxas", grupo: "totais" },
  { chave: "descontos", label: "Descontos", grupo: "totais" },
  { chave: "totalAPagar", label: "Total a pagar", grupo: "totais" },
  {
    chave: "declaracaoRecebimento",
    label: "Declaração de recebimento",
    grupo: "rodape"
  },
  {
    chave: "codigoBarrasNumeroErp",
    label: "Código de barras do número ERP",
    grupo: "rodape"
  }
];

export const CONFIG_IMPRESSAO_PEDIDO_GRUPOS = [
  {
    id: "cabecalho",
    label: "Cabeçalho / dados do pedido",
    icon: "fas fa-file-alt"
  },
  { id: "itens", label: "Itens", icon: "fas fa-list-ul" },
  { id: "totais", label: "Totais", icon: "fas fa-calculator" },
  { id: "rodape", label: "Rodapé", icon: "fas fa-file-signature" }
];

const KNOWN_KEYS = new Set(
  CONFIG_IMPRESSAO_PEDIDO_FIELDS.map(field => field.chave)
);

export const getDefaultConfigImpressaoPedido = () => {
  return CONFIG_IMPRESSAO_PEDIDO_FIELDS.reduce((acc, field) => {
    acc[field.chave] = true;
    return acc;
  }, {});
};

export const mergeConfigImpressaoPedido = partial => {
  const defaults = getDefaultConfigImpressaoPedido();
  if (!partial || typeof partial !== "object") {
    return defaults;
  }

  const merged = { ...defaults };
  KNOWN_KEYS.forEach(key => {
    if (Object.prototype.hasOwnProperty.call(partial, key)) {
      merged[key] = Boolean(partial[key]);
    }
  });
  return merged;
};

export const getConfigImpressaoPedidoFieldsByGrupo = grupo => {
  return CONFIG_IMPRESSAO_PEDIDO_FIELDS.filter(field => field.grupo === grupo);
};
